import "../sass/Page.scss";
import Gallery from "./Gallery";
import Entete from "./Entete";
import Lightbox from "./Lightbox";
import Footer from "./Footer";
import TopBar from "./TopBar";
import { useState, useEffect } from "react";
import { getStaticProps } from "../index";


export default function Portfolio({ date }) {
    console.log(date.getFullYear());
    
    let [etatPortfolio, setPortfolio] = useState(null);
    const [loaded, setLoaded] = useState(false);
    //On set le data du portfolio avec l'info de Contentful 
    //On initialise les états dans l'ancêtre commun
    const lightbox = useState(false);
    const [etatLightbox, setEtatLightbox] = lightbox;
    let etatProjetChoisi = useState(0);

    async function getData(locale) {

        setLoaded(false);
        const data = await getStaticProps(locale);
            setPortfolio(data);
            setLoaded(true);
    }

    function toggleLightbox() {


        let lightboxElm = document.querySelector(".Lightbox");

        if (etatLightbox === true) {
            document.body.style.overflow = 'scroll';
            lightboxElm.style.visibility = "hidden";

        }
        else {
            //Empecher l'utilisateur de scroll
            document.body.style.overflow = 'hidden';
            lightboxElm.style.visibility = "visible";

        }

        setEtatLightbox(!etatLightbox);

    }
  
    useEffect(() => {
       
        getData("fr-CA");
        // Run! Like go get some data from an API.

        console.log("i have been mounted");
    }, []);



    return (

        <>
        {loaded ? (
        <div>
            <div className="page">

                <TopBar locale={getData} />
                <Entete infoEntete={etatPortfolio.props.header} />
                <Gallery etatGalerie={etatPortfolio.props.gallery} toggleLightbox={toggleLightbox} etatProjetChoisi={etatProjetChoisi} />
                <Footer etatFooter={etatPortfolio.props.footer} />

            </div>
            <Lightbox etatLightbox={lightbox} etatGalerie={etatPortfolio.props.gallery} toggleLightbox={toggleLightbox} etatProjetChoisi={etatProjetChoisi} />
        </div>) : (<h2>Loading Data...</h2>)}
        </>

    );
}